import { useContext, useEffect, useMemo, useReducer, useState } from "react";
import { usePagination, useTable } from "react-table";
import { Get, Post2 } from "../Rutas/ApiRest";
import "../index.css"
import { RastreoInicial } from "../Model/Tablas/RastreoCarga";
import { Contexto } from "../Context/Contexto";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { tokens } from "../Context/Tokens";
import { Carga } from "../Rutas/Servicios";
import { HistorialCarga } from "../Model/Tablas/HistorialCarga";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { Excel } from "../Componentes/Excel";
import { BusquedaExcel } from "../Model/ExcelDTO";

function Historial()
{
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const fechaIn=new Date();
    fechaIn.setDate(fechaIn.getDate())
     const {SetMensajeEmergente,SetLoading}=useContext(MensajeContActualizacion)
     const {GuiaBusqueda}=useContext(GuiaBusquedaCont)
    const [fechas,dispachFecha]=useReducer(reducer,{fechaInicial:fechaIn.toLocaleDateString('en-CA'),fechaFinal:fechaIn.toLocaleDateString('en-CA')})
    const datos=[
        RastreoInicial
      ]
      const columns=useMemo(() => HistorialCarga, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)
      var cantidad=0
      function reducer(state:any,action:any)
    {
        switch(action.type)
        {
          case "cambio":return {
            ...state,[action.input.name]:action.input.value
          }
        }
    
      return state;
    }
    function cambio(event:any)
    {
      dispachFecha({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})

      const fechatemp=new Date(event.target.value)
      fechatemp.setDate(fechatemp.getDate()+59)

      const fechamin=new Date(fechas.fechaFinal)

      const fechaIniciales=new Date(event.target.value)

      if(fechamin>=fechatemp)
      {
        SetFechaFinalMostrar(fechatemp.toLocaleDateString('en-ZA').replace("/","-").replace("/","-"))
        dispachFecha({type:"cambio",input:{
            name:"fechaFinal",
            value:fechatemp.toLocaleDateString('en-ZA').replace("/","-").replace("/","-")
          }})

      }

      if(fechaIniciales>=fechamin)
      {
        
        fechaIniciales.setDate(fechaIniciales.getDate()+1)
        SetFechaFinalMostrar(fechaIniciales.toLocaleDateString('en-ZA').replace("/","-").replace("/","-"))
        dispachFecha({type:"cambio",input:{
            name:"fechaFinal",
            value:fechaIniciales.toLocaleDateString('en-ZA').replace("/","-").replace("/","-")
          }})
      }
      SetFechaFinalMostrarsMax(fechatemp.toLocaleDateString('en-ZA').replace("/","-").replace("/","-")) //cambiar a 'en-Ca' o a en-ZA
    }

    function cambio2(event:any)
    {
      dispachFecha({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
      SetFechaFinalMostrar(event.target.value)
      
    }

    

    const boletasLioren=(datos:any)=>
        {

            DescargarPdf(datos.UrlBoleta,"Documento"+datos.Guiahija)

        }


    const DescargarPdf=(base64:string,nombre:string)=>
        {
            const pdfLink ="data:application/pdf;base64,"+base64;
            const anchorElement = document.createElement('a');
            const fileName = nombre+".pdf";
            anchorElement.href = pdfLink;
            anchorElement.download = fileName;
            anchorElement.click();
            SetLoading(false)
        }    

    const [FechaFinalMostrars,SetFechaFinalMostrar]=useState<string>("")
    const [FechaFinalMostrarsMax,SetFechaFinalMostrarsMax]=useState<string>("")

    const llamar=()=>
    {
        if(fechas.fechaInicial=="" || fechas.fechaFinal=="")
        {
            SetMensajeEmergente("Ingrese fecha validas"); 	
        }else
        {
            SetLoading(true)
            const fechIn=new Date(fechas.fechaInicial)
            fechIn.setDate(fechIn.getDate()+59);
            const fechFin=new Date(fechas.fechaFinal)
            if(fechFin<=fechIn && fechFin>=new Date(fechas.fechaInicial))
            {
                
                var body={"ecode":Cli.lCasilla[Cli.Eleccion].ecode,
                "fechaIn": fechas.fechaInicial.replace("-","/").replace("-","/"),
                "fechaFin": fechas.fechaFinal.replace("-","/").replace("-","/")
                }

                const dato3=Post2(Carga.BusquedaFecha,JSON.stringify(body),"application/json",tok)
                dato3.then(resultado=>{
                    if(resultado!="")
                    {
                        Setdata(resultado)
                    }else
                    {
                        SetMensajeEmergente("No se encontraron Guias con ese rango de fechas")
                        SetLoading(false)
                    }
                    
                })
            }else
            {
                SetMensajeEmergente("Ingrese fechas con un maximo de 2 meses")
                SetLoading(false)
            }
            
        }
        SetLoading(false);
        
    }
   
     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
     },[GuiaBusqueda])


     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
     },[Cli.Eleccion])

     const ActualizarDatos=()=>
     {
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
                const historialcargas=Get(Carga.Historial.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@guiahija",GuiaBusqueda),"application/json",tok)
                historialcargas.then(resultado=>{Setdata(resultado);SetLoading(false)})
            }
        }

     }

          const {
            getTableProps, 
            getTableBodyProps, 
            headerGroups, 
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            pageOptions,
            gotoPage,
            setPageSize,
            pageCount,
            state,
            prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
                initialState:{
                    hiddenColumns:["UrlBoleta"]
                }
            },
            usePagination
        );

        const { pageIndex,pageSize } = state
    return (
        <>
        
        {data.length===0? <div className="col-12 py-2 py-sm-0">
            <div className="col-sm-12"><p className="subtitulo" >Busqueda Guias</p><div >
                <div className="row">
                <div className="col-sm-4 my-1 px-sm-2">
                <span>Fecha Inicio</span>
                <input type="date" defaultValue={fechaIn.toLocaleDateString('en-CA')} value={fechas.fechaInicial}  name="fechaInicial" onChange={cambio} style={{marginRight:"10px"} } ></input>
                </div>
                <div className="col-sm-4 my-1 px-sm-2">
                <span>Fecha Final </span><input type="date" name="fechaFinal" value={FechaFinalMostrars}   min={fechas.fechaInicial} max={FechaFinalMostrarsMax} onChange={cambio2} style={{marginRight:"10px"}}></input>
                </div>
                <div className="col-sm-4 my-1 px-sm-2">
                <button className="btn btn-success" onClick={()=>llamar()} >
        Buscar por fechas
    </button>
                </div>
                </div>
                </div> </div><br/><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id="Two"> <span className="content" >No Existen Compras realizadas en los últimos 6 meses.</span>

                    </div></div>:<> <div className="row">
            <div className="col-12 py-2 py-sm-0">
            <div className="col-12 py-2 py-sm-0">
            <p className="subtitulo" >Busqueda Guias</p><div >
                <div className="row">
                <div className="col-sm-4 my-1 px-sm-2">
                <span>Fecha Inicio</span>
                <input type="date" defaultValue={fechaIn.toLocaleDateString('en-CA')} value={fechas.fechaInicial}  name="fechaInicial" onChange={cambio} style={{marginRight:"10px"} } ></input>
                </div>
                <div className="col-sm-4 my-1 px-sm-2">
                <span>Fecha Final </span><input type="date" name="fechaFinal" value={FechaFinalMostrars}   min={fechas.fechaInicial} max={FechaFinalMostrarsMax} onChange={cambio2} style={{marginRight:"10px"}}></input>
                </div>
                <div className="col-sm-4 my-1 px-sm-2">
                <button className="btn btn-success" onClick={()=>llamar()} >
        Buscar por fechas
    </button>
                </div>
                </div>
                </div> <br/></div><br/><span>* Para ver informacion sobre el cobro de las DIPS favor hacer <a href="https://apps.eshopex.cl/pdf/E-1103003674-240321-1853.pdf" target="_blank" rel="noopener noreferrer">click Aqui</a></span>
              <div className="table-responsive" id="historial">
                     <table  {...getTableProps()} className="table table-hover table-sm table-bordered" id="tablaHistorial">
                       <thead style={{verticalAlign:"middle"}}>
                           {headerGroups.map((headerGroup) => (
                               <tr {...headerGroup.getHeaderGroupProps()}>
                                   {headerGroup.headers.map((column) => (
                                       <th {...column.getHeaderProps()}>
                                           {column.render('Header')}
                                       </th>
                                   ))}
                               </tr>
                           ))}
                       </thead>

                       <tbody {...getTableBodyProps()} style={{verticalAlign:"top",textAlign:"center"}} >
                           {page.map((row: any) => {
                               prepareRow(row)
                               let colore="#0d6efd"
                                if(row.cells[0].value===GuiaBusqueda+"")
                                {
                                    colore="#FFD700"
                                }
                               return (
                                   <tr  {...row.getRowProps()} style={{background:row.cells[0].value===GuiaBusqueda+""?"#00ad5f":"",color:row.cells[0].value===GuiaBusqueda+""?"#fff":""}} >
                                       {row.cells.map((cell: any) => {
                                        var datoss=""
                                        if(cell.column.Header==="Imagenes" && cell.value!=undefined && cell.value!="-")
                                        {
                                          datoss=cell.value.split(',')
                                          cantidad=cantidad+1
                                        }
                                           return (
                                               cell.column.Header==="Boleta/Factura" && cell.value !=undefined?
                                               cell.value==="Base64"?
                                                <td {...cell.getCellProps()}><a target="_blank" rel="noopener noreferrer" style={{cursor:"pointer",color:colore}}><i className="bi-search" style={{color:"black"}} onClick={ ()=>{SetLoading(true);boletasLioren(row.original)}}></i></a></td>:
                                                <td {...cell.getCellProps()}><a href={cell.value} target="_blank" rel="noopener noreferrer"><i className="bi-search" style={{color:"black"}}  ></i></a></td>
                                               :cell.column.Header==="Visualizar Dip" && cell.value!='-'?
                                               <td {...cell.getCellProps()}><a href={cell.value} target="_blank" rel="noopener noreferrer"><i className="bi-search" style={{color:"black"}}></i></a></td>
                                               :cell.column.Header==="Imagenes" && cell.value!="-"?
                                               datoss.length==2?<td {...cell.getCellProps()}>
                                                   <a className="nav-link collapsed" data-bs-target={"#components-n"+cantidad} data-bs-toggle="collapse" style={{cursor:"pointer",color:colore}}>Imagenes</a>
                                                       <ul id={"components-n"+cantidad} className="nav-content collapse" data-bs-parent="#sidebar-nav" style={{padding:"0"}}>
                                                            {datoss[0]!="-"?<div style={{paddingBottom:"20px"}}><a href={"https://apps.eshopex.cl/admin_sac/desconsolidador/getArchive?nombreArchivo="+datoss[0]} style={{color:colore}}> {datoss[0]} </a></div>  :null}
                                                            {datoss[1]!="-"?<a  href={"https://apps.eshopex.cl/admin_sac/desconsolidador/getArchive?nombreArchivo="+datoss[1]} style={{color:colore}}> {datoss[1]} </a> :null}
                                                       </ul>
                                                       
                                                   </td>:
                                               <td {...cell.getCellProps()} >-</td>
                                               :cell.column.Header==="Visualizar Despacho" && cell.value!='-'?
                                               <td {...cell.getCellProps()}><a href={cell.value} target="_blank" rel="noopener noreferrer"><i className="bi-truck" style={{color:"black"}}></i></a></td>:
                                               <td {...cell.getCellProps()} >{cell.render('Cell')}</td>
                                           );
                                       })}
                                   </tr>
                               );
                           })}
                       </tbody>
                   </table>   
              </div>
			  </div>
		  </div>
          {data.length>10?<>
            <div className="col-12 py-2 py-sm-0"><div className="col-sm-12">
            <div className="row">
                <div className="col-sm-9 my-1 px-sm-2">
                <div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
<a>
<button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                   
                   
                </a>
                
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                
                <a >
                <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                    
                   
                   
                </a>
               
            </div>
                </div>
                <div className="col-sm-2 my-1 px-sm-2">
                    <div style={{margin: '5px', justifyContent: 'center', alignItems: 'center'}}>
                        <span>Ver Filas </span> <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}  >
                    {
                        [10,25,50, 100].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                {pageSize}
                            </option>
                        ))
                    }
                </select>
                    </div>
                
                </div>
                </div></div> </div>
               
            </>:null}
            <div className="table-pagination" >
                <a>
                    <Excel contenido={BusquedaExcel}></Excel>
                </a>
            </div>
        </>
                    }
                   



            
        
       

        </>
    )
}

export default Historial;